import * as Authentication from "./Authentication"
import * as User from "./User"
import * as Product from "./products"
import * as Orders from "./order"
import * as Locations from "./Locations"
import * as Shipping from "./Shipping"
import * as Contact from "./Contact"
import * as Newsletter from "./Newsletter"

export {
  Authentication,
  User,
  Product,
  Orders,
  Locations,
  Shipping,
  Contact,
  Newsletter,
}
